import React from "react";
import styles from "./style.module.css";
import { Icon } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
function isStartofNum(str) {
    return str === "-" || str === "";
}
function hasNoTrailingSpaces(str) {
    return str[str.length - 1] !== " ";
}
function isFloat(str) {
    return hasNoTrailingSpaces(str) && (isStartofNum(str) || str === "." || !isNaN(Number(str)));
}
function isInt(str) {
    const num = Math.floor(Number(str));
    return (hasNoTrailingSpaces(str) &&
        (isStartofNum(str) ||
            (!isNaN(Number(str)) && num !== Infinity && (String(num) === str || String("0" + num) === str))));
}
export class LineInput extends React.PureComponent {
    input = null;
    constructor(props) {
        super(props);
        this.state = {
            tempVal: props.value || props.value === 0 ? (props.value ?? "") : props.defaultValue ? props.defaultValue : "",
            isEdit: false
        };
    }
    componentDidMount() {
        if (this.props.focus && this.input !== null) {
            this.input.focus();
            this.input.select();
        }
    }
    handleKeyPress(event) {
        const { isInstantChange } = this.props;
        const { tempVal } = this.state;
        if (event.key === "Enter" && tempVal !== undefined && (tempVal !== "" || isInstantChange)) {
            this.handleBlur(String(tempVal), true);
        }
    }
    handleChange(value) {
        const { inputType, updateInstant, isCheckbox, onChange, forceCommas } = this.props;
        switch (inputType) {
            case "float":
                if (!isFloat(value))
                    return;
                break;
            case "int":
                if (!isInt(value))
                    return;
                break;
        }
        this.setState({
            tempVal: forceCommas && !isNaN(parseInt(value)) ? parseInt(value.replace(/,/g, "")).toLocaleString() : value
        });
        if (updateInstant || isCheckbox) {
            return onChange?.(value);
        }
    }
    handleBlur(value, skipIsEdit = false) {
        const { onChange, min, max, inputType, forceCommas } = this.props;
        let retValue = value;
        switch (inputType) {
            case "float":
            case "int":
                if (isNaN(Number(retValue)))
                    retValue = "0";
        }
        if (min !== undefined && Number(value) < min) {
            retValue = min.toString();
        }
        if (max !== undefined && Number(value) > max) {
            retValue = max.toString();
        }
        if (forceCommas) {
            retValue = value.replace(/,/g, "");
        }
        this.setState({
            tempVal: undefined,
            isEdit: skipIsEdit ? this.state.isEdit : false
        });
        return onChange?.(retValue);
    }
    render() {
        const { label, topLabel, labelStyle, inputStyle, onChange, type, defaultValue, value, isDollar, focus, focusOnClick, leadingChar, isBox, isFullBox, isEditable, isCleanEditable, isShowEditable, isMediumBox, isGalleryBox, autoFocus, isScaleBox, borderColor, placeholder, showRight, style, isLocked, isDisabled, isDark, forceCommas, inputClassName, isPassword, isWarning, isSenseBox, warning, onFocus, inputName } = this.props;
        const { isEdit } = this.state;
        const iStyle = {
            width: type === "percent" ? "25px" : type === "integer" ? "50px" : undefined,
            ...inputStyle
        };
        if (isDisabled) {
            iStyle.border = "1px solid transparent";
            iStyle.background = "#F2F3F7";
        }
        return (React.createElement("div", { className: (isSenseBox ? styles.senseBox : "") +
                " " +
                (isEditable ? styles.editable : "") +
                " " +
                (isCleanEditable ? styles.cleanEditable : "") +
                " " +
                (isBox
                    ? styles.inputBoxHolder
                    : isMediumBox
                        ? styles.mediumBox
                        : isFullBox
                            ? styles.fullBox
                            : isGalleryBox
                                ? styles.galleryBox
                                : isScaleBox
                                    ? styles.scaleBox
                                    : styles.inputHolder) +
                " " +
                (showRight ? styles.fixRight : " ") +
                " " +
                (isShowEditable ? styles.showEditable : "") +
                " " +
                (isDark ? styles.darkMode : "") +
                " " +
                (isLocked ? styles.isLocked : ""), style: style ? style : {}, onClick: () => this.input && this.input.value === "No Constraint" && this.input.select(), title: isLocked ? (value || value === 0 ? String(value) : String(defaultValue ?? "")) : undefined },
            label && isBox !== true && (React.createElement("div", { className: styles.label, style: labelStyle ? labelStyle : {}, title: label }, label + ":")),
            isBox === true && label && React.createElement("div", { className: styles.absoluteLabel }, label),
            topLabel && (React.createElement("div", { className: styles.topLabel, style: labelStyle, title: topLabel }, topLabel)),
            isDollar && React.createElement("div", { className: styles.dollar }, "$"),
            leadingChar !== undefined && React.createElement("div", { className: styles.dollar }, leadingChar),
            React.createElement("div", { className: showRight ? styles.editIconRight : styles.editIcon, onClick: () => this.input?.focus() },
                React.createElement(FontAwesomeIcon, { className: "fa-w-16", icon: faEdit })),
            isLocked ? (value || value === 0 ? (value) : (defaultValue)) : (React.createElement("div", { className: styles.inputWrapper },
                isWarning && (React.createElement("div", { className: styles.warningIcon },
                    React.createElement(OverlayTrigger, { placement: "top", trigger: warning ? ["hover", "click"] : [], rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-top" },
                            React.createElement("div", { className: styles.popList }, warning)) },
                        React.createElement(Icon, { type: "warningRed", size: 18 })))),
                React.createElement("input", { autoFocus: autoFocus ? true : undefined, type: isPassword ? "password" : undefined, name: inputName ? inputName : isPassword ? "password" : undefined, autoComplete: "new-password", readOnly: isCleanEditable && !isEdit, style: borderColor
                        ? {
                            ...iStyle,
                            border: "1px solid " + borderColor
                        }
                        : { ...iStyle }, onFocus: (e) => {
                        if (focus || focusOnClick) {
                            e.target.select();
                            document.execCommand("copy");
                        }
                        const newState = { isEdit: true, tempVal: "" };
                        if (value !== undefined && value !== 0 && !forceCommas) {
                            newState.tempVal = value;
                        }
                        this.setState(newState);
                        if (onFocus) {
                            onFocus();
                        }
                        return;
                    }, onChange: (event) => this.handleChange(event.target.value), onBlur: onChange !== undefined ? (event) => this.handleBlur(event.target.value) : () => null, onKeyPress: (event) => this.handleKeyPress(event), value: value !== undefined &&
                        value !== null &&
                        // Boolean(value) !== false &&
                        !isEdit
                        ? forceCommas
                            ? value.toLocaleString()
                            : value
                        : this.state.tempVal !== undefined
                            ? this.state.tempVal
                            : defaultValue, className: (inputClassName ? inputClassName : "") +
                        " " +
                        (isDollar ? styles.dollarInput : styles.normal) +
                        " " +
                        (isWarning ? styles.hasWarningIcon : ""), ref: (input) => {
                        this.input = input;
                    }, placeholder: placeholder, disabled: isDisabled })))));
    }
}
export class CheckboxInput extends React.PureComponent {
    input = null;
    constructor(props) {
        super(props);
        this.state = {
            tempVal: props.value ?? props.defaultValue ?? false,
            isEdit: false
        };
    }
    componentDidMount() {
        if (this.props.focus && this.input !== null) {
            this.input.focus();
            this.input.select();
        }
    }
    render() {
        const { label, topLabel, labelStyle, inputStyle, onChange, defaultValue, value, isDollar, focus, focusOnClick, leadingChar, isBox, isFullBox, isEditable, isCleanEditable, isShowEditable, isMediumBox, isGalleryBox, autoFocus, isScaleBox, borderColor, placeholder, showRight, style, isLocked, isDisabled, isDark, inputClassName, isPassword, isWarning, isSenseBox, warning, onFocus } = this.props;
        const { isEdit } = this.state;
        const iStyle = {
            width: "16px",
            height: "16px",
            marginTop: "0px",
            ...inputStyle
        };
        if (isDisabled) {
            iStyle.border = "1px solid transparent";
            iStyle.background = "#F2F3F7";
        }
        return (React.createElement("div", { className: (isSenseBox ? styles.senseBox : "") +
                " " +
                (isEditable ? styles.editable : "") +
                " " +
                (isCleanEditable ? styles.cleanEditable : "") +
                " " +
                (isBox
                    ? styles.inputBoxHolder
                    : isMediumBox
                        ? styles.mediumBox
                        : isFullBox
                            ? styles.fullBox
                            : isGalleryBox
                                ? styles.galleryBox
                                : isScaleBox
                                    ? styles.scaleBox
                                    : styles.inputHolder) +
                " " +
                (showRight ? styles.fixRight : " ") +
                " " +
                (isShowEditable ? styles.showEditable : "") +
                " " +
                (isDark ? styles.darkMode : "") +
                " " +
                (isLocked ? styles.isLocked : ""), style: style ? style : {}, onClick: () => this.input && this.input.value === "No Constraint" && this.input.select(), title: isLocked ? (value ?? defaultValue ?? false).toString() : undefined },
            label && isBox !== true && (React.createElement("div", { className: styles.label, style: labelStyle ? labelStyle : {}, title: label }, label + ":")),
            isBox === true && label && React.createElement("div", { className: styles.absoluteLabel }, label),
            topLabel && (React.createElement("div", { className: styles.topLabel, style: labelStyle, title: topLabel }, topLabel)),
            isDollar && React.createElement("div", { className: styles.dollar }, "$"),
            leadingChar !== undefined && React.createElement("div", { className: styles.dollar }, leadingChar),
            React.createElement("div", { className: showRight ? styles.editIconRight : styles.editIcon, onClick: () => this.input?.focus() },
                React.createElement(FontAwesomeIcon, { className: "fa-w-16", icon: faEdit })),
            isLocked ? (value === undefined ? (value) : (defaultValue)) : (React.createElement("div", { className: styles.inputWrapper },
                isWarning && (React.createElement("div", { className: styles.warningIcon },
                    React.createElement(OverlayTrigger, { placement: "top", trigger: warning ? ["hover", "click"] : [], rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-top" },
                            React.createElement("div", { className: styles.popList }, warning)) },
                        React.createElement(Icon, { type: "warningRed", size: 18 })))),
                React.createElement("input", { autoFocus: autoFocus ? true : undefined, type: "checkbox", name: isPassword ? "password" : undefined, autoComplete: "new-password", readOnly: isCleanEditable && !isEdit, style: borderColor
                        ? {
                            ...iStyle,
                            border: "1px solid " + borderColor
                        }
                        : { ...iStyle }, onFocus: (e) => {
                        if (focus || focusOnClick) {
                            e.target.select();
                            document.execCommand("copy");
                        }
                        this.setState({ isEdit: true, tempVal: value ?? false });
                        if (onFocus) {
                            onFocus();
                        }
                        return;
                    }, onChange: (event) => onChange?.(event.target.checked), checked: value, defaultChecked: defaultValue, className: (inputClassName ? inputClassName : "") +
                        " " +
                        (isDollar ? styles.dollarInput : styles.normal) +
                        " " +
                        (isWarning ? styles.hasWarningIcon : ""), ref: (input) => {
                        this.input = input;
                    }, placeholder: placeholder, disabled: isDisabled })))));
    }
}
